/**
 * 바닥(너비·깊이) 크기 제약.
 * 박람회 표준 1×1 부스 = 3.3 m × 3.3 m 기준으로,
 * 일반 사용자는 4×4 부스까지 허용한다.
 * 문의 후 승인된 엔터프라이즈 계정은 행사장 급(최대 1 km)까지 확장한다.
 */

/** 박람회 표준 부스 한 칸 한 변 (m) */
export const BOOTH_UNIT_M = 3.3;

/** 일반 플랜에서 허용하는 최대 부스 변 수 (4×4) */
export const STANDARD_MAX_BOOTHS = 4;

export type RoomSizePlan = 'standard' | 'enterprise';

export const ROOM_SIZE_LIMITS = {
  minWidth: 2,
  minDepth: 2,
  minHeight: 2,
  maxHeight: 8,
  /** 일반: 박람회 4×4 부스 (3.3 × 4 = 13.2 m) */
  standard: {
    maxWidth: BOOTH_UNIT_M * STANDARD_MAX_BOOTHS,
    maxDepth: BOOTH_UNIT_M * STANDARD_MAX_BOOTHS,
    maxBooths: STANDARD_MAX_BOOTHS,
  },
  /** 엔터프라이즈(로그인 + 문의 승인): 최대 1 km × 1 km */
  enterprise: {
    maxWidth: 1000,
    maxDepth: 1000,
    maxBooths: null as number | null,
  },
  inquiryUrl: 'https://www.thinkingfriends.co.kr/inquiry',
} as const;

export interface FloorSizeLimits {
  minWidth: number;
  minDepth: number;
  maxWidth: number;
  maxDepth: number;
}

export function getFloorSizeLimits(plan: RoomSizePlan = 'standard'): FloorSizeLimits {
  const tier = ROOM_SIZE_LIMITS[plan];
  return {
    minWidth: ROOM_SIZE_LIMITS.minWidth,
    minDepth: ROOM_SIZE_LIMITS.minDepth,
    maxWidth: tier.maxWidth,
    maxDepth: tier.maxDepth,
  };
}

export function clampFloorSize(width: number, depth: number, plan: RoomSizePlan = 'standard') {
  const limits = getFloorSizeLimits(plan);
  return {
    width: Number(Math.max(limits.minWidth, Math.min(limits.maxWidth, width)).toFixed(2)),
    depth: Number(Math.max(limits.minDepth, Math.min(limits.maxDepth, depth)).toFixed(2)),
  };
}

export function formatFloorMaxLabel(plan: RoomSizePlan = 'standard') {
  const { maxWidth, maxDepth } = getFloorSizeLimits(plan);
  if (plan === 'enterprise') return `${maxWidth} × ${maxDepth} m`;
  return `${maxWidth} × ${maxDepth} m (박람회 ${STANDARD_MAX_BOOTHS}×${STANDARD_MAX_BOOTHS} 부스)`;
}
